import * as theme from "../theme";
import Button from "react-bootstrap/Button";
import { useEffect, useState, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBrokerInformation } from "../store/broker";
import { toast } from "react-toastify";
import { tr } from "date-fns/locale";
import  BmsView  from "../components/Admin/BmsView"
import { getBrokerageInformation, getDetails } from "../store/brokerage";

const BMSAdmin = () => {
  return <BMSManagementPane></BMSManagementPane>;
};
const BMSManagementPane = () => {

  const dispatch = useDispatch();
  const broker = useSelector(getBrokerInformation);
  let data = { brokerage_code: broker.information.brokerages[0].code };
  const brokerage_info = useSelector(getBrokerageInformation);
  useEffect(() => {
    dispatch(getDetails(data))
  }, []);

  return (
    <BmsView
      isQadmin={false}
      brokerageCode={broker.information.brokerages[0].code}
    ></BmsView>
  );
};

export default BMSAdmin;
